<template>
    <notifications group="foo" />
</template>

<script>
    export default {
        props: ['message', 'type'],
        methods: {
            show() {
                if(this.message) {
                    this.$notify({
                        'group': 'foo',
                        'type': this.type,
                        'title': this.message,
                        'duration': 50000
                    });
                }
            }
        },
        mounted: function() {
            this.show();
        }

    }
</script>
